export const isTestEnv = process.env.NODE_ENV === 'test'
export const MARCO_URL = isTestEnv ? 'test://marco.test' : process.env.REACT_APP_MARCO_URL || ''
